import { useMemo } from "react";

import { useSavedDraftModelsQuery } from "@/apollo/types";

import { useDrafts } from "../../QueryEditor/useModelDraft";
import { DraftModelItemType, ModelItemType } from "../SidebarFactory";

export const useDraftItems = () => {
  const { data, loading } = useSavedDraftModelsQuery({
    fetchPolicy: "cache-and-network",
  });

  const { drafts } = useDrafts();

  const items = useMemo(() => {
    const rawDrafts = data?.savedDrafts ?? [];
    // Do sorting on the raw array first because we know each raw draft has a createdAt.
    const sortedRawDrafts = rawDrafts
      .slice()
      .sort((a, b) => b.createdAt.localeCompare(a.createdAt));

    const unpublished: ModelItemType[] = sortedRawDrafts.map((model) => ({
      itemType: "model" as const,
      id: model.id,
      model,
    }));

    const draftModelsItems: DraftModelItemType[] = drafts.map((draftModel) => ({
      itemType: "draft" as const,
      id: draftModel.id,
      draftModel,
    }));

    return [...draftModelsItems, ...unpublished];
  }, [data, drafts]);

  return { items, loading };
};
